module.exports = __webpack_public_path__ + "img/product-item-bg.e2df849a.png";